module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-list"
  }, _vm._l((_vm.item.combos), function(version, index) {
    return _c('div', {
      key: version.name
    }, [_c('binary', {
      attrs: {
        "item": version,
        "type": _vm.type,
        "auto-open": index === 0,
        "is-new": index === 0
      },
      on: {
        "recordUserDownload": _vm.recordUserDownload,
        "containerDeployValidate": _vm.containerDeployValidate
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0bf6f426!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/versionList.vue
// module id = vrTe
// module chunks = 16